import object from 'helpers/object'


export const initialState = {
  sales: [],
  categories: [],
  isFetching: true,
}

export const setFetching = (state, payload) => (
  object.setIn(state, [ 'isFetching' ], payload)
)

export const setCategories = (state, payload) => (
  object.setIn(state, [ 'categories' ], payload)
)

export const setSales = (state, payload) => (
  object.setIn(state, [ 'sales' ], payload)
)
